import {deepEqual, LinkProps as RouterLinkProps, useChildMatches} from "@tanstack/react-router";

export type Snaplink = Omit<RouterLinkProps, "children"> & {
    path?: string;
}

export function isSameLink(a: Snaplink, b: Snaplink) {
    const ad = {to: a.to ?? a.path, params: a.params, search: a.search};
    const bd = {to: b.to ?? b.path, params: b.params, search: b.search};
    return deepEqual(ad, bd);
}

export function useRouterSnaplink(): Snaplink | undefined {
//    const routerState = useRouterState();
//     const matches = useMatches();
// //    const routeMatch = useMatch({strict: false});
//     const deepestMatch = matches[matches.length - 1];
    const matches = useChildMatches();
    const deepestMatch = matches[matches.length - 1];

    const rv = deepestMatch
        ? {
            to: deepestMatch.fullPath,
            params: deepestMatch.params,
        } as Snaplink
        : undefined;

    return rv;

    //
    // const [prev, setPrev]
    //     = useState<Snaplink | undefined>(rv);
    //
    //
    //
    // if (!!rv && (!prev || !isSameLink(prev, rv))) {
    //     setPrev(rv);
    // }
    // return prev;
}
